<section aeBillboardLabel class="billboard billboard-slim sitemap">
	<div class="billboard-header">
		<h1 class="billboard-title text-center">Sitemap</h1>
	</div>

	<div class="billboard-body">
		<div class="col-lg-7 mx-auto px-3 mt-3 mb-3 text-center">
			<label class="form-label fs-4 fw-bold" for="sitemap-search">
				What do you want to do?
			</label>
			<input
				autocomplete="off"
				class="form-control"
				id="sitemap-search"
				placeholder="Search tasks"
				type="search"
				[formControl]="queryControl"
			/>
		</div>
		<fieldset class="form-group text-center">
			<legend class="form-label fs-5 mb-2 fw-bold">Show results for</legend>
			<div class="audience-filters justify-content-center">
				<label class="form-check" for="sitemap-audience-user">
					<input
						class="form-check-input"
						id="sitemap-audience-user"
						type="checkbox"
						[formControl]="audienceControls.user"
					/>
					<span class="form-check-label">User</span>
				</label>
				<label class="form-check" for="sitemap-audience-customer">
					<input
						class="form-check-input"
						id="sitemap-audience-customer"
						type="checkbox"
						[formControl]="audienceControls.customer"
					/>
					<span class="form-check-label">Customer</span>
				</label>
				<label class="form-check" for="sitemap-audience-admin">
					<input
						class="form-check-input"
						id="sitemap-audience-admin"
						type="checkbox"
						[formControl]="audienceControls.admin"
					/>
					<span class="form-check-label">Admin</span>
				</label>
				<label class="form-check" for="sitemap-audience-super-admin">
					<input
						class="form-check-input"
						id="sitemap-audience-super-admin"
						type="checkbox"
						[formControl]="audienceControls.superAdmin"
					/>
					<span class="form-check-label">Super Admin</span>
				</label>
			</div>
		</fieldset>

		<div class="visually-hidden" role="status">
			{{ results.length }} matching results found.
		</div>

		<div>
			@if (results.length > 0) {
				<ul class="result-list">
					@for (entry of results; track entry.id) {
						<li class="result-item">
							<div class="application-label text-center">
								{{ applicationLabels[entry.application] }}
							</div>
							<div class="result-content mx-auto text-center">
								<a class="result-title" [href]="entry.href">{{
									entry.title
								}}</a>
								<div>
									<p
										class="result-guidance d-inline-block mw-100 mb-0 text-start"
									>
										{{ entry.guidance }}
									</p>
								</div>
							</div>
						</li>
					}
				</ul>
			} @else {
				<div class="text-center text-muted py-4">No results found</div>
			}
		</div>
	</div>
</section>
